import { StorageService } from './../shared/services/storage.service';
import { Component, OnInit } from '@angular/core';
import { LedgerService } from "../shared/services/ledger.service";
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, QuerySnapshot, DocumentData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageEntry, LogEntry, LedgerEntry, SaleEntry } from '../shared/services/ledger-entry';
import { AuthService } from '../shared/services/auth.service';
declare var M: any;

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
// add Buyer/Client Tax Id
export class OrdersComponent implements OnInit {
  error: string;
  updateMode: boolean = false;
  rate: number;
  taxIds = {};
  buyersTaxIds = {};
  ready = false;
  pending = false;
  rePending = false;
  readyOrders = false;
  completed = false;
  constructor(public authService: AuthService,
    private db: AngularFirestore,
    private db2: AngularFirestore,
    private ledgerService: LedgerService,
    private storageService: StorageService) {
    //this.ledgerService.getLedger();
  }
  ngOnInit() {
    // check permission .. test flow .. fix update log in storage service (test multiple scenarios) .. 
    //?  remove extra fields in add entry on order .. add tool tip for option buttons .. 
    // backup orders ? back up all db ? ..
    var me = this;
    setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);
    setTimeout(function () { me.getSale(); }, 1000);// fix Latency
    // this.getSale();
    this.getStorage();
    this.setUser();
  }
  setUser() {
    this.userProfile = this.authService.getUserProfile;

    this.user = this.authService.getUser;
    this.storageEntry.user = this.userProfile.displayName;
    this.storageEntry.userEmail = this.userProfile.email;
    this.storageEntry.userNumber = this.userProfile.number;
    this.storageEntry.userId = this.user.uid;
    this.LedgerEntrySale.user = this.userProfile.displayName;
    this.LedgerEntrySale.userEmail = this.userProfile.email;
    this.LedgerEntrySale.userNumber = this.userProfile.number;
    this.LedgerEntrySale.userId = this.user.uid;
    this.LedgerEntryCost.user = this.userProfile.displayName;
    this.LedgerEntryCost.userEmail = this.userProfile.email;
    this.LedgerEntryCost.userNumber = this.userProfile.number;
    this.LedgerEntryCost.userId = this.user.uid;
    if (!this.saleEntry.approved) {
      this.saleEntry.approvedUser = this.userProfile.displayName;
      this.saleEntry.approvedUserEmail = this.userProfile.email;
      this.saleEntry.approvedUserNumber = this.userProfile.number;
      this.saleEntry.approvedUserId = this.user.uid;
    }
    if (!this.saleEntry.shipped) {
      this.saleEntry.shippedUser = this.userProfile.displayName;
      this.saleEntry.shippedUserEmail = this.userProfile.email;
      this.saleEntry.shippedUserNumber = this.userProfile.number;
      this.saleEntry.shippedUserId = this.user.uid;
    }
  }
  editId;
  userProfile;
  user;
  order = [];
  addingNew = true;
  backup = false;
  fullView = false;
  totalCashFlow: number;
  ledger: Observable<any[]>;
  storage: Observable<any[]>;
  fileReaded: any;
  safeToFilter: boolean = true;
  totalCost = 0; totalRetail = 0; totalQ = 0; totalActualCost = 0;
  totalDebit = 0; totalCredit = 0;
  myEntry: string;
  editMode: boolean = false;
  incomeStatement = { "container": [], "directCost": [], "directCostCr": [], "sales": [], "totalSales": 0, "exp": [], "taxes": [], "zero": [], "totalZero": 0, "expOp": [], "totalExpOp": 0, "expOpCr": [], "totalExpOpCr": 0, "totalTaxes": 0, "totalExp": 0, "totalContainer": 0, "totalDirectCost": 0, "totalDirectCostCr": 0, "totalCogs": 0 };
  editType;
  entryToEdit: any = {};
  autoComplete = {
    buyerTaxId: {},
    buyer: {},
    buyerAddress: {},
    buyerPhone: {},
  };
  autoCompleteKeys = {
    buyerTaxId: {},
    buyer: {},
    buyerAddress: {},
    buyerPhone: {},
  };
  autoCompleteString = JSON.stringify(this.autoComplete); autoCompleteArray = []; codeArray = [];
  storageEntry: StorageEntry = {
    id: "",
    supplier: "",
    shipmentNumber: 0,
    code: "",
    storageLocation: "",
    name: "",
    buyer: "",
    cost: 0,
    actualCost: 0,
    retailPrice: 0,
    quantity: 0,
    log: [],
    logs: [],
    user: "",
    userId: "",
    userNumber: "",
    userEmail: "",
    url:"",
  }
  saleEntry: SaleEntry = {
    user: "",
    userEmail: "",
    userNumber: "",
    userId: "",
    date: new Date(),
    buyer: "",
    buyerTaxId: "",
    buyerPhone: "",
    buyerAddress:"",
    order: [],
    approved: false,
    approvedUser: "",
    approvedUserEmail: "",
    approvedUserNumber: "",
    approvedUserId: "",
    shipped: false,
    shippedUser: "",
    shippedUserEmail: "",
    shippedUserNumber: "",
    shippedUserId: "",
    reason: "",
    downPay: 0,
    ledgerEntrySale: [],ledgerEntryAR:[],ledgerEntryCost: []
  }
  LedgerEntrySale: LedgerEntry = {
    id: "",
    TXN: "Emei-co",
    supplier: "",
    shipmentNumber: 0,
    codeCredit: "Cash",
    codeDebit: "A/R",
    creditName: "",
    creditValue: 0,
    date: new Date(),
    debitName: "",
    debitValue: 0,
    cashFlow: 0,
    comment: "AUTO ",
    user: "",
    userId: "",
    userEmail: "",
    userNumber: "",
  }
  LedgerEntryAR: LedgerEntry = {
    id: "",
    TXN: "Emei-co",
    supplier: "",
    shipmentNumber: 0,
    codeCredit: "A/R",
    codeDebit: "Sales",
    creditName: "",
    creditValue: 0,
    date: new Date(),
    debitName: "",
    debitValue: 0,
    cashFlow: 0,
    comment: "AUTO ",
    user: "",
    userId: "",
    userEmail: "",
    userNumber: "",
  }
  LedgerEntryCost: LedgerEntry = {
    id: "",
    TXN: "Emei-co",
    supplier: "",
    shipmentNumber: 0,
    codeCredit: "Merchandise inventory",
    codeDebit: "COGS",
    creditName: "",
    creditValue: 0,
    date: new Date(),
    debitName: "",
    debitValue: 0,
    cashFlow: 0,
    comment: "AUTO ",
    user: "",
    userId: "",
    userEmail: "",
    userNumber: "",
  }
  stock = {};
  generalSaleCollection = { generalSale: [] };
  disabled = true;
  show = true;
  editOrder = false;
  totalRetailOrder = 0; totalQOrder = 0;
  completedOrders = [];
  calculateOrderTotal() {
    this.totalRetailOrder = 0; this.totalQOrder = 0;
    this.saleEntry.order.forEach(elem => {
      this.totalQOrder += elem.quantity;
      this.totalRetailOrder += elem.quantity * elem.retailPrice;
    })
  }
  getOrderTotal(order) {
    let totalRetailOrder1 = 0; let totalQOrder1 = 0;
    order.forEach(elem => {
      totalQOrder1 += elem.quantity;
      totalRetailOrder1 += elem.quantity * elem.retailPrice;
    })
    return totalRetailOrder1;
  }
  showOrder(entry) {
    let res = true;
    this.saleEntry.order.length ? this.editId == entry.id ? res = false : null : res = false;
    return res
  }
  viewEntry(data, id) {
    var sl = JSON.parse(JSON.stringify(data));
    if (this.saleEntry.buyer == "" || this.editId != id) {
      this.editId = id;
      this.saleEntry = sl;
      data.approved ? this.editOrder = false : this.editOrder = true;
    } else {
      this.editId = "";
      this.saleEntry = {
        user: "",
        userEmail: "",
        userNumber: "",
        userId: "",
        date: new Date(),
        buyerTaxId: "",
        buyer: "",
        buyerPhone: "",
        buyerAddress: "",
        order: [],
        approved: false,
        approvedUser: "",
        approvedUserEmail: "",
        approvedUserNumber: "",
        approvedUserId: "",
        shipped: false,
        shippedUser: "",
        shippedUserEmail: "",
        shippedUserNumber: "",
        shippedUserId: "",
        reason: "",
        downPay: 0,
        ledgerEntrySale: [],ledgerEntryAR:[],ledgerEntryCost: []
      };
    }
    this.calculateOrderTotal();
  }
  approveEntry(data, id) {
    this.editId = id;
    this.saleEntry = JSON.parse(JSON.stringify(data));
    if (this.shipmentAvailable(this.saleEntry.order)) {
      this.setUser();
      this.saleEntry.approved = true;
      this.saveEntry();
      this.error = ""
      this.getStorage();
    }
    else
      this.error = "quantity changed and exceeds the stock"

  }
  shipEntry(data, id) {
    this.editId = id;
    this.setUser();

    this.saleEntry = JSON.parse(JSON.stringify(data));
    if (this.shipmentAvailable(this.saleEntry.order)) {
      // this.LedgerEntrySale.supplier = 
      //! have to get all items from order based on supplier and possibly shipment then add entry for each supplier
      let supplierProducts = { suppliers: [], products: {} };
      this.LedgerEntrySale.comment += id;
      this.LedgerEntryAR.comment += id;
      this.LedgerEntryCost.comment += id;
      this.saleEntry.order.forEach(product => {
        if (!supplierProducts.suppliers.includes(product.supplier)) {
          supplierProducts.suppliers.push(product.supplier);
          supplierProducts.products[product.supplier] = []
        };
        supplierProducts.products[product.supplier].push(product);
      });
      
      supplierProducts.suppliers.forEach(supplier => {
        supplierProducts.products[supplier].forEach(product => {
          // sale Value= total Retail price used
          // cost Value= Total of Actual cost used in order
          this.LedgerEntrySale.supplier = supplier;
          this.LedgerEntrySale.shipmentNumber = product.shipmentNumber;
          // this.LedgerEntrySale.creditValue += product.quantity * product.retailPrice;
          // this.LedgerEntrySale.debitValue += product.quantity * product.retailPrice;

          this.LedgerEntryAR.supplier = supplier;
          this.LedgerEntryAR.shipmentNumber = product.shipmentNumber;
          this.LedgerEntryAR.creditValue += product.quantity * product.retailPrice;
          this.LedgerEntryAR.debitValue += product.quantity * product.retailPrice;
          // test auto ledger entry
          // handle return?
          this.LedgerEntryCost.supplier = supplier;
          this.LedgerEntryCost.shipmentNumber = product.shipmentNumber;
          this.LedgerEntryCost.creditValue += product.quantity * product.actualCost;
          this.LedgerEntryCost.debitValue += product.quantity * product.actualCost;

        })

        this.shipEntryHelper(data);
      })
      var me = this;
      this.saleEntry.shipped = true;
      // add Delay ?
      // copy order id
      var that = this;
      setTimeout(function () {
        that.saveEntry();
        var me = that;
        data.order.forEach(elem => {
          elem.buyer = data.buyer;
          me.stock[elem.code].buyer = data.buyer
          me.storageService.updateStorageTask(elem.id, elem, "sale", me.stock[elem.code]);
        })
        that.error = "";
        that.getStorage();
       }, 1000);// fix Latency


    }
    else
      this.error = "quantity changed and exceeds the stock";
  }
  copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    M.toast({ html: 'Copied to Clipboard!' })
  }
  shipEntryHelper(data) {
// fix ledger id index aand do return

    this.LedgerEntrySale.creditValue += this.saleEntry.downPay;
    this.LedgerEntrySale.debitValue += this.saleEntry.downPay;
    this.ledgerService.addTask(this.LedgerEntrySale)
      // .then(refSale => {
      
      // this.saleEntry.ledgerEntrySale.push({ id: refSale.id, supplier: this.LedgerEntrySale.supplier});
      // console.log(refSale, this.saleEntry);
      this.ledgerService.addTask(this.LedgerEntryAR).then(refAR => {

        this.saleEntry.ledgerEntryAR.push({ id: refAR.id, supplier: this.LedgerEntryAR.supplier });

        this.ledgerService.addTask(this.LedgerEntryCost).then(refCost => {
          this.saleEntry.ledgerEntryCost.push({ id: refCost.id, supplier: this.LedgerEntryCost.supplier });

          this.LedgerEntrySale = {
            id: "",
            TXN: "Emei-co",
            supplier: "",
            shipmentNumber: 0,
            codeCredit: "Cash",
            codeDebit: "A/R",
            creditName: "",
            creditValue: 0,
            date: new Date(),
            debitName: "",
            debitValue: 0,
            cashFlow: 0,
            comment: "AUTO ",
            user: "",
            userId: "",
            userEmail: "",
            userNumber: "",
          }
          this.LedgerEntryAR = {
            id: "",
            TXN: "Emei-co",
            supplier: "",
            shipmentNumber: 0,
            codeCredit: "A/R",
            codeDebit: "Sales",
            creditName: "",
            creditValue: 0,
            date: new Date(),
            debitName: "",
            debitValue: 0,
            cashFlow: 0,
            comment: "AUTO ",
            user: "",
            userId: "",
            userEmail: "",
            userNumber: "",
          }
          this.LedgerEntryCost = {
            id: "",
            TXN: "Emei-co",
            supplier: "",
            shipmentNumber: 0,
            codeCredit: "Merchandise inventory",
            codeDebit: "COGS",
            creditName: "",
            creditValue: 0,
            date: new Date(),
            debitName: "",
            debitValue: 0,
            cashFlow: 0,
            comment: "AUTO ",
            user: "",
            userId: "",
            userEmail: "",
            userNumber: "",
          }
          this.setUser();
        })
      // })
    })


  }
  shipmentAvailable(order) {
    var validate = false;
    order.forEach(product => {
      if (this.stock[product.code].quantity >= product.quantity)
        validate = true;
      else
        validate = false;
    })

    return validate;
  }
  pendEntry(data, id) {
    this.editId = id;
    this.saleEntry = JSON.parse(JSON.stringify(data));
    this.setUser();
    this.saleEntry.approved = false;
    this.saveEntry();
  }
  actualCostEdit() {
    //  console.log(this.disabled);
    // this.disabled++;
    // if (this.disabled == 2) {
    //   this.disabled = 0;
    if (confirm('Are you sure you want to enter the Stock Cost manually?')) {
      let link = document.querySelector('#autocompleteactualCost');
      if (link) {
        link.removeAttribute('disabled'); this.disabled = !this.disabled;
      }
    }
    // }
  }
  addOrderEntry(data: StorageEntry, id) {
    let entry: StorageEntry = JSON.parse(JSON.stringify(data));
    delete entry.log;
    delete entry.logs;
    !this.saleEntry.order.includes(data) ? this.saleEntry.order.push(entry) : null;
  }
  deleteOrderEntry(entry) {
    if (confirm('Are you sure you want to delete this item?')) {

      const index = this.saleEntry.order.indexOf(entry);
      if (index > -1) {
        this.saleEntry.order.splice(index, 1);
      }
    }
  }
  addNew() {
    // this.addingNew = !this.addingNew;
    if (this.addingNew) {
      localStorage.setItem('addingNew', 't')
      this.addingNew = !this.addingNew;
    } else {
      localStorage.setItem('addingNew', '')
      this.addingNew = !this.addingNew;

    }
  }
  showBackup() {
    this.backup = !this.backup;
  }
  getFullView() {
    this.fullView = !this.fullView;
  }

  roundValue(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;

  }
  getSale() {
    // console.log("calling server for ledger");
    // 
    this.storage = this.db.collection("generalSale", ref => ref.orderBy("date", "asc"))
      .snapshotChanges()
      .pipe(
        map(
          actions => {
            this.ready = true;
            this.pending = false; this.rePending = false; this.readyOrders = false; this.completed = false;
            this.completedOrders = [];
            return actions.map(a => {
              //Get document data
              const data = a.payload.doc.data() as SaleEntry;
              const id = a.payload.doc.id;
              const date = this.formatDate(data.date);
              console.log(data);
              this.addAutoComplete(data);
              this.generalSaleCollection.generalSale.push(data);
              !data.approved && data.approvedUser == '' ? this.pending = true : null;
              !data.approved && data.approvedUser != '' ? this.rePending = true : null;
              data.approved && !data.shipped ? this.readyOrders = true : null;
              data.approved && data.shipped ? this.completed = true : null;


              // this.generalLedgerCollection.generalLedger.push(data);
              // let unix_timestamp = data.date['seconds']
              // var date = new Date(unix_timestamp * 1000); //console.log(date);
              // Math.abs(2 % 2) == 1
              //Use spread operator to add the id to the document data
              data.date = this.getDate(data.date)
              data.shipped && data.approved ? this.completedOrders.push({ id, date, data }) : null;

              return { id, date, data };
            });
          }));
  }
  getStorage() {

    this.db2.collection("generalStorage").get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.totalCost = 0; this.totalRetail = 0; this.totalQ = 0; this.totalActualCost = 0;
        querySnapshot.forEach((doc: any) => {
          const data = doc.data() as StorageEntry;
          const id = doc.id;
          // console.log(data);
          this.stock[data.code] = data;
          this.totalCost += data.cost; this.totalRetail += data.retailPrice; this.totalQ += data.quantity;
          this.totalActualCost += data.actualCost;
          this.addAutoComplete(data);
          this.show = true;
          // this.generalLedgerCollection.generalLedger.push(data);
          // let unix_timestamp = data.date['seconds']
          // var date = new Date(unix_timestamp * 1000); //console.log(date);
          // Math.abs(2 % 2) == 1
          //Use spread operator to add the id to the document data
          // this.stock.push(data);
        });
      });
    // console.log(this.stock);



  }
  calculateCost(storageEntry: StorageEntry) {
    // get storage shipment and number then get rate .. get cogs then get provisional tax from income statement .. rate = ((cost*rate)*(cogs+tax)/(cogs)), rate*cost
    let shipmentNumber = storageEntry.shipmentNumber;
    let supplier = storageEntry.supplier;

    //console.log("filterstart");
    let db = this.db;//handle case zero ? ask dad ?
    //get container
    let collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "Container"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["container"] = [];
        this.incomeStatement["totalContainer"] = 0;
        this.incomeStatement["totalCogs"] = 0;
        querySnapshot.forEach((doc: any) => {
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["container"].push(data);
          this.incomeStatement["totalContainer"] -= data["debitValue"];
          this.incomeStatement["totalCogs"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, data };
        })
      });
    //get direct cost
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "Direct Cost"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["directCost"] = [];
        this.incomeStatement["totalDirectCost"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["directCost"].push(data);
          this.incomeStatement["totalDirectCost"] -= data["debitValue"];
          this.incomeStatement["totalCogs"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });

    //get direct cost Cr
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeCredit', '==', "Direct Cost"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["directCostCr"] = [];
        this.incomeStatement["totalDirectCostCr"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["directCostCr"].push(data);
          this.incomeStatement["totalDirectCostCr"] += this.roundValue(data["debitValue"]);
          this.incomeStatement["totalCogs"] += this.roundValue(data["debitValue"]);
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });





    //get Exp
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "Exp"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["exp"] = [];
        this.incomeStatement["totalExp"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["exp"].push(data);
          this.incomeStatement["totalExp"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });

    //get provisional tax
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "provisional tax"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["taxes"] = [];
        this.incomeStatement["totalTaxes"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["taxes"].push(data);
          this.incomeStatement["totalTaxes"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });

    //get Sales
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeCredit', '==', "Sales"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["sales"] = [];
        this.incomeStatement["totalSales"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["sales"].push(data);
          this.incomeStatement["totalSales"] += this.roundValue(data["debitValue"]);
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    let rate = 0;
    collection = db.collection("generalShipments", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data();
          //Get document id
          const id = doc.id;
          //  console.log(data.rate);
          data.rate ? rate = data.rate : null;
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    var me = this;
    setTimeout(function () {
      me.rate = ((storageEntry.cost * rate) * (me.incomeStatement.totalCogs + (-1 * me.incomeStatement.totalTaxes)) / (me.incomeStatement.totalCogs))
      me.storageEntry.actualCost <= me.storageEntry.cost * me.rate ? me.storageEntry.actualCost = me.storageEntry.cost * me.rate : null;// handle rate not found set to zero
      //  console.log(storageEntry.cost, rate, me.incomeStatement.totalCogs, (-1 * me.incomeStatement.totalTaxes), me.incomeStatement.totalCogs);
    }, 500);
  }
  getDate(element) {
    let unix_timestamp = element['seconds']
    // Create a new JavaScript Date object based on the timestamp
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    return new Date(unix_timestamp * 1000);
  }
  formatDate(date) {
    var today = this.getDate(date); //console.log(date);
    var res = "";
    res = today.toString();

    // this should be safe since nothing else in the date string contains a opening paren
    var index = res.indexOf("GMT");

    // if the index exists
    if (~index) {
      res = res.substr(0, index);
    }
    return res;
  }
  isToday(dateParameter) {
    var today = new Date();
    //  console.log("is today?", dateParameter.getDate() === today.getDate() && dateParameter.getMonth() === today.getMonth() && dateParameter.getFullYear() === today.getFullYear());

    return dateParameter.getDate() === today.getDate() && dateParameter.getMonth() === today.getMonth() && dateParameter.getFullYear() === today.getFullYear();
  }
  getArrayOfKeysFromObject(obj) {
    var arr = [];
    Object.keys(obj).forEach(function (key) {
      //var value = data[key];
      arr.push(key);
    });
    return arr;
  }
  addAutoComplete(data) {
    // 
    var me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      //var value = data[key];
      if (me.autoComplete[key][data[key]] != "" && data[key] != "" && data[key]) {
        me.autoComplete[key][data[key]] = "";
        me.autoCompleteArray.push(data[key]);
        key == "buyerTaxId" ? me.taxIds[data.buyerTaxId] = { buyer: data.buyer, buyerTaxId: data.buyerTaxId, phone: data.buyerPhone, address: data.buyerAddress } : null;
        key == "buyer" ? me.buyersTaxIds[data.buyer] = { buyer: data.buyer, buyerTaxId: data.buyerTaxId, phone: data.buyerPhone, address: data.buyerAddress } : null;
      }

    });
    me.autoCompleteString = JSON.stringify(me.autoComplete);
    //console.log(this.autoComplete);
  }
  updateValueOnAutocomplete() {
    let me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      let val = (<HTMLInputElement>document.getElementById('autocomplete' + key)).value;
      // debugger
      if (val) {
        if (key != 'shipmentNumber') {
          if (key == 'date') {
            me.saleEntry[key] = new Date(val);
          }
          else
            me.saleEntry[key] = val;
        }
        else {
          me.saleEntry[key] = Number.parseFloat(val);
        }
        if (key == "buyerTaxId" && me.taxIds[val]) {
          me.saleEntry.buyer = me.taxIds[val].buyer;
          me.saleEntry.buyerTaxId = me.taxIds[val].buyerTaxId;
          me.saleEntry.buyerPhone = me.taxIds[val].phone;
          me.saleEntry.buyerAddress = me.taxIds[val].address;

        }
        if (key == "buyer" && me.buyersTaxIds[val]) {
          me.saleEntry.buyer = me.buyersTaxIds[val].buyer;
          me.saleEntry.buyerTaxId = me.buyersTaxIds[val].buyersTaxId;
          me.saleEntry.buyerPhone = me.buyersTaxIds[val].phone;
          me.saleEntry.buyerAddress = me.buyersTaxIds[val].address;
        }

        // console.log(me.storageEntry[key]);
      }
      //
    });
  }
  clear() {
    this.saleEntry.buyerTaxId = "";
    this.saleEntry.buyer = "";
    this.saleEntry.buyerPhone = "";
    this.saleEntry.buyerAddress = "";
  }
  //TODO filter orders by buyer
  // getRecordToUpdate(code) {

  // }
  filterLedgerFromServerByText(): void {
    this.updateValueOnAutocomplete();
    //  console.log("filter called");
    // let keys = Object.keys(this.autoComplete.code);
    // // keys.length != this.codeArray.length ? this.codeArray = keys : null;
    // keys.includes(this.storageEntry.code) ? this.updateMode = true : this.updateMode = false;
    // this.updateMode ? this.getRecordToUpdate(this.storageEntry.code) : null;
    // enter edit mode
    let buyer = this.saleEntry.buyer;
    let buyerId = this.saleEntry.buyerTaxId;


    //  console.log("filter", supplier, shipmentNumber, code, name, storageLocation);
    if (this.saleEntry.buyer == "" && this.safeToFilter) {
      this.getSale();
      return;
    } //console.log("filter check", this.autoCompleteArray.includes(supplier) && this.safeToFilter, this.autoCompleteArray , supplier, this.safeToFilter);
    if ((this.autoCompleteArray.includes(buyer) ||
      this.autoCompleteArray.includes(buyerId)) && this.safeToFilter) {
      //console.log("filterstart");
      let db = this.db;//handle case zero ? ask dad ?
      let collection = db.collection("generalSale", ref => ref.where('buyerTaxId', '==', buyerId));


      this.storage = collection.snapshotChanges().pipe(
        map(
          actions => {
            this.ready = true;
            this.pending = false; this.rePending = false; this.readyOrders = false; this.completed = false;
            this.completedOrders = [];
            return actions.map(a => {
              //Get document data
              const data = a.payload.doc.data() as SaleEntry;
              const id = a.payload.doc.id;
              const date = this.formatDate(data.date);
              console.log(data);
              // this.addAutoComplete(data);
              // this.generalSaleCollection.generalSale.push(data);
              !data.approved && data.approvedUser == '' ? this.pending = true : null;
              !data.approved && data.approvedUser != '' ? this.rePending = true : null;
              data.approved && !data.shipped ? this.readyOrders = true : null;
              data.approved && data.shipped ? this.completed = true : null;


              // this.generalLedgerCollection.generalLedger.push(data);
              // let unix_timestamp = data.date['seconds']
              // var date = new Date(unix_timestamp * 1000); //console.log(date);
              // Math.abs(2 % 2) == 1
              //Use spread operator to add the id to the document data
              data.date = this.getDate(data.date)
              data.shipped && data.approved ? this.completedOrders.push({ id, date, data }) : null;

              return { id, date, data };
            });
          }));
    }


  }
  editEntry(ledgerEntry, id) {
    //  console.log(ledgerEntry, id);
    //Set taskToEdit and editMode
    this.storageEntry = JSON.parse(JSON.stringify(ledgerEntry));
    window.scrollTo(0, 0);
    this.setUser();
    this.editMode = true;
    this.updateMode = true;
    this.editType = "";
    this.entryToEdit.id = id;
    this.entryToEdit.data = JSON.parse(JSON.stringify(ledgerEntry));
    setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);
    //Set form value
    //this.myEntry = ledgerEntry.description;
  } //edit
  handleEdit() {
    //  console.log(this.editType, this.entryToEdit.data);
    switch (this.editType) {
      case "edit":
        this.storageEntry = JSON.parse(JSON.stringify(this.entryToEdit.data));
        break;
      case "sale":
        this.storageEntry = JSON.parse(JSON.stringify(this.entryToEdit.data));
        this.storageEntry.quantity = 0;
        break;
      case "return":
        this.storageEntry = JSON.parse(JSON.stringify(this.entryToEdit.data));
        this.storageEntry.quantity = 0;
        break;
      case "new":
        this.storageEntry = JSON.parse(JSON.stringify(this.entryToEdit.data));
        this.storageEntry.shipmentNumber = 0;
        break;
      default:
        // code block
        break
    }
  }
  saveEntry() {
    // this.setUser();
    this.storageService.updateSale(this.editId, this.saleEntry);
    //balance values

    //set edit mode to false and clear form
    this.updateMode = false;
    this.editMode = false;
    this.editType = "";
    this.entryToEdit = {};
    this.saleEntry = {
      user: "",
      userEmail: "",
      userNumber: "",
      userId: "",
      date: new Date(),
      buyerTaxId: "",
      buyer: "",
      buyerPhone: "",
      buyerAddress: "",
      order: [],
      approved: false,
      approvedUser: "",
      approvedUserEmail: "",
      approvedUserNumber: "",
      approvedUserId: "",
      shipped: false,
      shippedUser: "",
      shippedUserEmail: "",
      shippedUserNumber: "",
      shippedUserId: "",
      reason: "",
      downPay: 0,
      ledgerEntrySale: [],ledgerEntryAR:[],ledgerEntryCost: []
    }
    this.editId = "";
    this.setUser();
    // this.getStorage();
    this.myEntry = "";

  } //saveTask
  deleteTask(entry) {
    if (confirm('Are you sure you want to delete this item?')) {
      //Get the entry id
      let taskId = entry.id;
      // this.totalActualCost -= entry.data.actualCost;
      //delete the entry
      this.storageService.deleteSale(taskId);
    }
  } //deleteTask
  exportJSON() {
    var a = document.createElement("a");
    var file = new Blob([JSON.stringify(this.generalSaleCollection)], { type: 'application/json' });
    a.href = URL.createObjectURL(file);
    a.download = 'backup.json';
    a.click();
    //https://firebase.google.com/docs/firestore/manage-data/export-import
    //console.log("https://firebase.google.com/docs/firestore/manage-data/export-import");
  }
  importJSON(csv: any) {
    this.safeToFilter = false;
    this.fileReaded = csv.target.files[0];

    let reader: FileReader = new FileReader();
    reader.readAsText(this.fileReaded);
    //console.log(reader.result)
    reader.onload = (e) => {

      let result = reader.result.toString();
      let json = JSON.parse(result);
      //console.log(json)
      for (let i = 0; i < json["generalSale"].length; i++) {

        this.saleEntry = json["generalSale"][i];
        // Object.keys(json["generalSale"]).forEach(function (key) {

        //   this.SaleEntry[key] = json["generalSale"][i][key];
        // });
        //console.log(this.SaleEntry)
        this.saveEntry();
        this.saleEntry = {
          user: "",
          userEmail: "",
          userNumber: "",
          userId: "",
          date: new Date(),
          buyerTaxId: "",
          buyer: "",
          buyerPhone: "",
          buyerAddress: "",
          order: [],
          approved: false,
          approvedUser: "",
          approvedUserEmail: "",
          approvedUserNumber: "",
          approvedUserId: "",
          shipped: false,
          shippedUser: "",
          shippedUserEmail: "",
          shippedUserNumber: "",
          shippedUserId: "",
          reason: "",
          downPay: 0,
          ledgerEntrySale: [], ledgerEntryAR: [],ledgerEntryCost: []

        }
        this.safeToFilter = true;
      }
    }
  }
}

